import React, { useState } from "react";
import DeveloperPortalLayout from "../layout/DeveloperPortalLayout";

const SettingsBilling: React.FC = () => {
  const [apiKeyVisible, setApiKeyVisible] = useState(false);
  const [apiKey] = useState("sk-jrny_5b9e2f1a6c8d4f0b9a8e7d6c5b4a3a2x8f2");

  const maskedKey = "sk-jrny_••••••••••••••••••••••••x8f2";

  return (
    <DeveloperPortalLayout>
      <div className="view-header">
        <h2>Settings & Billing</h2>
        <p>Manage your API keys, subscription plan, and review usage logs.</p>
      </div>

      <section className="dashboard-card">
        <div className="card-header">
          <h3><i className="fa fa-key"></i> API Key Management</h3>
        </div>
        <div className="card-body api-key-box">
          <div style={{ marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ fontSize: '13px', fontWeight: 600, color: '#475569' }}>Production API Key</span>
            <span style={{ fontSize: '10px', background: 'rgba(16, 185, 129, 0.1)', color: '#10b981', padding: '2px 6px', borderRadius: '4px', fontWeight: 700 }}>LIVE</span>
          </div>

          <div className="key-display">
            <span>{apiKeyVisible ? apiKey : maskedKey}</span>
            <div style={{ marginLeft: 'auto', display: 'flex', gap: '8px' }}>
              <button 
                onClick={() => setApiKeyVisible(!apiKeyVisible)}
                style={{ background: 'none', border: 'none', color: '#64748b', cursor: 'pointer' }}
              >
                <i className={`fa fa-eye${apiKeyVisible ? '-slash' : ''}`}></i>
              </button>
              <button 
                className="btn btn-sm btn-outline-secondary"
                style={{ fontSize: '12px', padding: '4px 12px', borderRadius: '6px' }}
              >
                <i className="fa fa-copy"></i> Copy
              </button>
              <button 
                className="btn btn-sm btn-outline-danger"
                style={{ fontSize: '12px', padding: '4px 12px', borderRadius: '6px', color: '#ef4444', borderColor: 'rgba(239, 68, 68, 0.2)' }}
              >
                <i className="fa fa-refresh"></i> Regenerate
              </button>
            </div>
          </div>

          <div style={{ fontSize: '12px', color: '#64748b', marginBottom: '24px' }}>
            <i className="fa fa-clock-o"></i> Created Jan 15, 2026 <span>|</span> Last used 2 minutes ago
          </div>

          <div className="usage-progress" style={{ borderTop: '1px solid #f1f5f9', paddingTop: '24px' }}>
            <div className="progress-info">
              <span>Requests used this month</span>
              <span>450 / 1,000</span>
            </div>
            <div className="progress-bar">
              <div className="fill" style={{ width: '45%' }}></div>
            </div>
            <div className="progress-meta">
              <span style={{ color: '#10b981', fontWeight: 600 }}><i className="fa fa-check-circle"></i> Usage is healthy</span>
              <span>Resets Mar 1, 2026</span>
            </div>
          </div>
        </div>
      </section>

      <section className="dashboard-card">
        <div className="card-header">
          <h3><i className="fa fa-credit-card"></i> Plans & Billing</h3>
          <button className="btn btn-sm btn-outline-secondary" style={{ fontSize: '12px', borderRadius: '6px' }}>Manage Subscription</button>
        </div>
        <div className="card-body">
          <div className="pricing-grid">
            {/* Basic Plan */}
            <div className="price-card active">
              <div className="plan-name" style={{ color: '#64748b' }}>Basic</div>
              <div className="price">$49<span>/month</span></div>
              <p className="desc">For individual developers and small prototypes.</p>
              <ul className="features">
                <li><i className="fa fa-check"></i> 1,000 API requests/month</li>
                <li><i className="fa fa-check"></i> Basic ingredient search</li>
                <li><i className="fa fa-check"></i> Community support</li>
              </ul>
              <button className="plan-btn current">Current Plan</button>
            </div>

            {/* Pro Plan */}
            <div className="price-card popular">
              <div style={{ position: 'absolute', top: '12px', right: '12px', background: '#d1fae5', color: '#059669', fontSize: '10px', fontWeight: 700, padding: '2px 8px', borderRadius: '4px' }}>MOST POPULAR</div>
              <div className="plan-name" style={{ color: '#10b981' }}>Pro</div>
              <div className="price">$199<span>/month</span></div>
              <p className="desc">For growing teams with production workloads.</p>
              <ul className="features">
                <li><i className="fa fa-check"></i> 50,000 API requests/month</li>
                <li><i className="fa fa-check"></i> Full ingredient database</li>
                <li><i className="fa fa-check"></i> Priority support</li>
                <li><i className="fa fa-check"></i> 5 API keys</li>
              </ul>
              <button className="plan-btn upgrade">Upgrade to Pro <i className="fa fa-arrow-right"></i></button>
            </div>

            {/* Enterprise Plan */}
            <div className="price-card">
              <div className="plan-name" style={{ color: '#1e293b' }}>Enterprise</div>
              <div className="price">Custom</div>
              <p className="desc">For large-scale deployments and custom integrations.</p>
              <ul className="features">
                <li><i className="fa fa-check"></i> Unlimited API requests</li>
                <li><i className="fa fa-check"></i> Dedicated account manager</li>
                <li><i className="fa fa-check"></i> SLA guarantee (99.99%)</li>
                <li><i className="fa fa-check"></i> Custom ML model training</li>
              </ul>
              <button className="plan-btn">Contact Sales <i className="fa fa-arrow-right"></i></button>
            </div>
          </div>
        </div>
      </section>

      <section className="dashboard-card">
        <div className="card-header">
          <h3><i className="fa fa-list-alt"></i> Usage Logs <span style={{ fontSize: '12px', fontWeight: 400, color: '#64748b', marginLeft: '12px' }}>Last 10 API calls</span></h3>
          <button className="btn btn-sm btn-outline-secondary" style={{ fontSize: '12px', borderRadius: '6px' }}>View All Logs</button>
        </div>
        <div className="card-body" style={{ padding: 0 }}>
          <table className="logs-table">
            <thead>
              <tr>
                <th>Request ID</th>
                <th>Timestamp</th>
                <th>Method</th>
                <th>Endpoint</th>
                <th>Status</th>
                <th>Latency</th>
              </tr>
            </thead>
            <tbody>
              {[
                { id: "req_a1b2c3", time: "Feb 27, 20:02:18", method: "GET", path: "/v3/ingredients/search", status: 200, latency: "23ms" },
                { id: "req_d4e5f6", time: "Feb 27, 20:01:45", method: "POST", path: "/v3/formulations/create", status: 201, latency: "145ms" },
                { id: "req_g7h8i9", time: "Feb 27, 20:00:22", method: "GET", path: "/v3/ingredients/ing_8f3k2m/nutrients", status: 200, latency: "18ms" },
                { id: "req_j0k1l2", time: "Feb 27, 19:58:59", method: "POST", path: "/v3/formulations/fm_2k9p/optimize", status: 429, latency: "4ms", err: true },
                { id: "req_m3n4o5", time: "Feb 27, 19:57:11", method: "GET", path: "/v3/ingredients/search", status: 200, latency: "31ms" },
                { id: "req_p6q7r8", time: "Feb 27, 19:55:44", method: "GET", path: "/v3/marketplace/models", status: 200, latency: "56ms" },
                { id: "req_s9t0u1", time: "Feb 27, 19:54:11", method: "POST", path: "/v3/formulations/create", status: 400, latency: "12ms", warn: true }
              ].map((log, i) => (
                <tr key={i}>
                  <td className="mono">{log.id}</td>
                  <td>{log.time}</td>
                  <td><span className={`method ${log.method}`}>{log.method}</span></td>
                  <td className="mono">{log.path}</td>
                  <td>
                    <span className={`status ${log.err ? 'err' : log.warn ? 'warn' : ''}`}>
                      {log.status}
                    </span>
                  </td>
                  <td>{log.latency}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </DeveloperPortalLayout>
  );
};

export default SettingsBilling;
